import List from '@utils/list'
const { Search, Jurisdiction, Table } = List

const search = new Search('purset.rate')
  .placeholder('searchPlaceholder')

const jurisdiction = new Jurisdiction()
  .lib('add').to('Purset.Rate.Add')
  .lib('modify').modify('Purset.Rate.Modify')
  .lib('delete').del('/srmTaxExchangeRate/deleteTaxExchangeRateByIds', process.env.VUE_APP_PURCHASE_API)

const table = new Table('purset.rate')
  .add('taxTypeNo')
  .add('taxTypeName')
  .add('taxRateSign')
  .add('taxRate')
  .add('remarks')

export default new List()
  .url('/srmTaxExchangeRate/getTaxExchangeRatePage', process.env.VUE_APP_PURCHASE_API)
  .search(search)
  .jurisdiction(jurisdiction)
  .table(table)
  .end()
